module.exports = __webpack_public_path__ + "static/media/okex.923b3364.svg";